import { create } from 'zustand';

export type LeftTab = 'photos' | 'templates' | 'text' | 'backgrounds' | 'shapes';

export type Toast = {
  id: string;
  kind: 'info' | 'success' | 'error';
  message: string;
};

interface UiState {
  leftTab: LeftTab;
  setLeftTab: (tab: LeftTab) => void;
  toasts: Toast[];
  pushToast: (toast: Omit<Toast, 'id'>) => void;
  dismissToast: (id: string) => void;
}

export const useUiStore = create<UiState>((set) => ({
  leftTab: 'photos',
  setLeftTab: (tab) => set({ leftTab: tab }),
  toasts: [],
  pushToast: (toast) =>
    set((state) => ({
      toasts: [...state.toasts, { ...toast, id: crypto.randomUUID() }],
    })),
  dismissToast: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}));
